import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    informations: {
        id: '',
        email: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        avatar_url: '',
        missing_attributes: [],
        super_admin: false,
        permissions: {},
        company_id: '',
        twitch_username: '',
        rights: [],
        domain: '',
        access_token: '',
    },
    has_admin_rights: false,
    oauthRoutes: {},
};

const computeOnboardingStep = (action) => {
    const { payload } = action;

    if (!payload) return 0;

    if (payload.has_recordings) return 6;
    if (payload.has_templates) return 5;
    if (payload.validated_phone_number) return 4;
    if (payload.default_company_id) return 3;
    if (payload.has_admin_rights) return 2;
    return 0;
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        loginUser: (state, action) => ({
            ...state,
            informations: {
                loggedIn: true,
                ...action.payload,
                onboardingStep: computeOnboardingStep(action),
            },
        }),
        logout: (state) => ({
            ...state,
            informations: initialState,
        }),
        setOAuthRoutes: (state, action) => ({
            ...state,
            oauthRoutes: action.payload,
        }),
        setAdditionalInformation: (state, action) => ({
            ...state,
            [action.payload.informationName]: action.payload.informationData,
        }),
    },
});

export const { loginUser, setOAuthRoutes, logout, setAdditionalInformation } = userSlice.actions;

export default userSlice.reducer;
